// v8 RC starts several storage reads on construction and leaves sibling
// rejections unhandled if IndexedDB is unavailable. Check storage first,
// without creating the RC instance or collecting any installation data.
export async function assertFeatureFlagStorage(): Promise<void> {
  const factory = window.indexedDB
  if (!factory) throw new Error('Feature flag storage unavailable')
  const name = 'carepro-feature-flags-storage-check'
  await new Promise<void>((resolve, reject) => {
    const request = factory.open(name)
    request.onerror = () =>
      reject(new Error('Feature flag storage unavailable'))
    request.onsuccess = () => {
      request.result.close()
      // This temporary database contains no stores or user data.
      try {
        factory.deleteDatabase(name)
      } catch (_) {
        // Cleanup denial must not throw from an IndexedDB event handler.
      }
      resolve()
    }
  })
}
